// extracted by mini-css-extract-plugin
export var cardIcon = "_b5-4";
export var checkboxCard = "_b5-0";
export var checkboxCardSelected = "_b5-3";
export var disabled = "_b5-1";
export var outerBorder = "_b5-2";
export var spacerMedium = "_b5-7";
export var spacerSmall = "_b5-6";
export var spacerXsmall = "_b5-5";